import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f8be8e10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon bi-chevron-left" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = { class: "mb-4 p-4 rounded-3 container-lg container-fluid" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-lg-4 col-md-6 col-12 mb-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "First Name")
], -1))
const _hoisted_11 = { class: "border rounded-3 p-2" }
const _hoisted_12 = { class: "col-lg-4 col-md-6 col-12 mb-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Middle Name")
], -1))
const _hoisted_14 = { class: "border rounded-3 p-2" }
const _hoisted_15 = { class: "col-lg-4 col-md-6 col-12 mb-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Last Name")
], -1))
const _hoisted_17 = { class: "border rounded-3 p-2" }
const _hoisted_18 = { class: "col-md-6 col-12 mb-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "User Name")
], -1))
const _hoisted_20 = { class: "border rounded-3 p-2" }
const _hoisted_21 = { class: "col-md-6 col-12 mb-3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Email")
], -1))
const _hoisted_23 = { class: "border rounded-3 p-2" }
const _hoisted_24 = ["href"]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "col-md-6 col-12 mb-3" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Mobile")
], -1))
const _hoisted_28 = { class: "border rounded-3 p-2" }
const _hoisted_29 = { class: "col-md-6 col-12 mb-3" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Department")
], -1))
const _hoisted_31 = { class: "border rounded-3 p-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.profileData?.profile_picture?.length > 1)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.profileData?.profile_picture,
            alt: _ctx.profileData?.first_name,
            width: "75",
            height: "75",
            class: "rounded-circle"
          }, null, 8, _hoisted_3))
        : (_openBlock(), _createElementBlock("div", _hoisted_4)),
      _createVNode(_component_Button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
        class: "my-3 p-button-raised p-button-text"
      }, {
        default: _withCtx(() => [
          _hoisted_5,
          _createTextVNode(" Back")
        ]),
        _: 1
      })
    ]),
    _hoisted_6,
    _createElementVNode("section", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("h6", _hoisted_11, _toDisplayString(_ctx.profileData?.first_name || "-"), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("h6", _hoisted_14, _toDisplayString(_ctx.profileData?.middle_name || "-"), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("h6", _hoisted_17, _toDisplayString(_ctx.profileData?.last_name || "-"), 1)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("h6", _hoisted_20, _toDisplayString(_ctx.profileData?.username || "-"), 1)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("h6", _hoisted_23, [
            (_ctx.profileData?.email)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: `mailto:${_ctx.profileData?.email}?subject=BHMIS`
                }, _toDisplayString(_ctx.profileData?.email), 9, _hoisted_24))
              : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString("-")))
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("h6", _hoisted_28, _toDisplayString(_ctx.profileData?.mobile || "-"), 1)
        ]),
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("h6", _hoisted_31, _toDisplayString(_ctx.profileData?.department || "-"), 1)
        ])
      ])
    ])
  ]))
}